export const viewerFragment = `
  id
  name
  profileImage
  email
  createdAt
  owners {
    results {
      id
      username
      profileImage
      name
      rank
      corpName
    }
  }
`
